import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderContentComponent } from './components/loader-content/loader-content.component';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [
    MatDialogContent,
    MatButtonModule,
    CommonModule,
    LoaderContentComponent
  ],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {title: string,text: string}
  ) { }
}
